import React, { useState } from 'react';
import {useAuth} from "../contexts/auth-context";
import Sidebar from '../../components/Sidebar';

const Layout = ({children}) => {
    const auth = useAuth();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    if (!auth.user?.token) {
        return <>{children}</>;
    }

    return (
        <div className="min-h-screen bg-gray-100 flex">
            {/* Sidebar */}
            <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col md:ml-64">
                {/* Header */}
                <header className="bg-white shadow-sm border-b border-gray-200">
                        <div className="flex items-center justify-between px-4 py-3">
                            {/* Mobile menu button */}
                            <button
                                onClick={toggleSidebar}
                                className="text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 md:hidden"
                            >
                                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                            
                            {/* Title - only show on mobile */}
                            <h1 className="text-lg font-semibold text-gray-900 md:hidden">Property Manager</h1>
                            
                            {/* Spacer for desktop */}
                            <div className="hidden md:block flex-1"></div>
                            
                            {/* User info - always visible */}
                            <div className="flex items-center space-x-3">
                                <div className="flex items-center space-x-2">
                                    <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                                        <span className="text-white text-sm font-medium">
                                            {(auth.user.user?.firstName || auth.user.user?.username || 'U').charAt(0).toUpperCase()}
                                        </span>
                                    </div>
                                    <div className="hidden sm:block">
                                        <p className="text-sm font-medium text-gray-900">
                                            {auth.user.user?.firstName && auth.user.user?.lastName 
                                                ? `${auth.user.user.firstName} ${auth.user.user.lastName}`
                                                : auth.user.user?.username || 'User'
                                            }
                                        </p>
                                        <p className="text-xs text-gray-500">
                                            {auth.user.user?.role || 'User'}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={auth.logout}
                                    className="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full p-1"
                                    title="Logout"
                                >
                                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                    </svg>
                                </button>
                            </div>
                            
                            {/* Spacer for mobile centering */}
                            <div className="w-6 md:hidden"></div>
                        </div>
                </header>
                
                {/* Main Content */}
                <main className="flex-1 p-6">
                    <div className="max-w-7xl mx-auto">
                        {children}
                    </div>
                </main>

                {/* Footer */}
                <footer className="bg-gray-800 text-white p-4 mt-auto">
                    <div className="max-w-7xl mx-auto">
                        <div className="flex justify-between items-center">
                            <span>© 2026 Property Management System</span>
                            <span>Version 1.0.0</span>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Layout;